const operateModule = {
  namespaced: true,
  state: {
    searchForm: {
      time: '',
      operater: ''
    },
    dataList: [],
    operateData: {}
  },
  getters: {
    getSearchForm: (state) => state.searchForm,
    getDataList: (state) => state.dataList,
  },
  mutations: {
    setSearchForm(state, formData) {
      state.searchForm = formData
    },
    clearSearchForm(state) {
      state.searchForm = {
        time: '',
        operater: ''
      }
      // state.dataList = []
    },
    setDataList(state, newDataList) {
      state.dataList = newDataList
    },
    setOperateData(state, row) {
      console.log(row)
      state.operateData = row
    }
  },
  actions: {
    search({ commit }) {
      // TODO: API

      const searchResult = Array.from({ length: 10 }).map(() => ({
        // TODO: 待串接資料移除假資料
        date: `20xx-xx-xx xx:xx:${Math.floor(Math.random() * 900)}`,
        operater: '王ＸＸ',
        event: 'abcXXX'
      }))

      // 更新 dataList
      commit('setDataList', searchResult)
    },
    clearSearch({ commit }) {
      // Clear the search form by calling the clearSearchForm mutation
      commit('clearSearchForm')
    }
  }
}

export default operateModule
